module.exports = new __parcel__URL__("badgeCheckIcon.5cf60fa2.svg").toString();